<template>
  <div>
    <!-- Our info area start here -->
    <div class="our-info" data-background="/assets/images/bg/our-info.jpg">
      <div class="container">
        <div class="row align-items-center">
          <form @submit.prevent="submitForm" class="space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <input
                  type="text"
                  v-model="form.name"
                  :placeholder="$t('loqt9p')"
                  class="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
                />
              </div>
              <div>
                <input
                  type="email"
                  v-model="form.email"
                  :placeholder="$t('l2ylcr')"
                  class="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
                />
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <input
                  type="text"
                  v-model="form.phone"
                  :placeholder="$t('v01s7d')"
                  class="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
                />
              </div>
              <div>
                <input
                  type="text"
                  v-model="form.message"
                  :placeholder="$t('9we5pk')"
                  class="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
                />
              </div>
            </div>
            <div class="text-center">
              <button
                type="submit"
                class="bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg"
              >
                {{ $t("itencg") }}
                <i class="fa-solid fa-arrow-right-long ml-2"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Our info area end here -->
    <!-- 页脚区域 -->
    <footer
      class="footer bg-image"
      data-background="/assets/images/bg/footer-bg.jpg"
    >
      <div class="container">
        <div class="pt-65 pb-65">
          <div class="row g-4">
            <div
              class="col-xl-4 col-md-8 wow fadeInUp"
              data-wow-duration="1.2s"
              data-wow-delay=".2s"
            >
              <div class="footer__item">
                <div class="footer__item-title">
                  <h4>{{ $t("3kc6tv") }}</h4>
                  <span class="footer__item-title-line"></span
                  ><span class="footer__item-title-line2"></span>
                </div>
                <p>{{ $t("7feraq") }}</p>
                <!-- <a href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29581.552527417!2d-77.04440883230183!3d38.80089850193032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b0f02c6539a9%3A0xacc6091466dd9068!2s901 N Pitt St Suite 170%2C Alexandria%2C VA 22314%2C USA!5e0!3m2!1sen!2sbd!4v1694324425557!5m2!1sen!2sbd"
                class="footer__item-map-popup map-popup">View Map <i class="fa-solid fa-location-arrow"></i></a> -->
              </div>
            </div>
            <div
              class="col-xl-4 col-md-8 wow fadeInUp"
              data-wow-duration="1.4s"
              data-wow-delay=".4s"
            >
              <div class="footer__item">
                <div class="footer__item-title">
                  <h4>{{ $t("aiii6l") }}</h4>
                  <span class="footer__item-title-line"></span
                  ><span class="footer__item-title-line2"></span>
                </div>
                <ul>
                  <li class="pb-3">
                    <a
                      ><i
                        class="fa-solid fa-location-dot pe-1 primary-color"
                      ></i>
                      {{ $t("y1na3h") }}
                    </a>
                  </li>
                  <li class="pb-3">
                    <a href=""
                      ><i
                        class="fa-solid fa-phone-volume pe-1 primary-color"
                      ></i>
                      +86 18629577925
                    </a>
                  </li>
                  <li style="text-transform: none">
                    <a href="mailto:sunfeng.zhang@sre-power.com"
                      ><i class="fa-solid fa-envelope pe-1 primary-color"></i>
                      sunfeng.zhang@sre-power.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="col-xl-4 col-md-8 wow fadeInUp"
              data-wow-duration="1.6s"
              data-wow-delay=".6s"
            >
              <div class="footer__item">
                <div class="footer__item-title">
                  <h4>{{ $t("1b7fxp") }}</h4>
                  <span class="footer__item-title-line"></span
                  ><span class="footer__item-title-line2"></span>
                </div>
                <ul class="footer__item-list">
                  <li class="pb-1">
                    <a :href="localePath('/solutions/battery-swap')"
                      ><i
                        class="fa-solid fa-chevron-right pe-1 primary-color"
                      ></i>
                      {{ $t("x0zeot") }}
                    </a>
                  </li>
                  <li class="pb-1">
                    <a :href="localePath('/products/charger')"
                      ><i
                        class="fa-solid fa-chevron-right pe-1 primary-color"
                      ></i>
                      {{ $t("5xblq2") }}
                    </a>
                  </li>
                  <li class="pb-1">
                    <a :href="localePath('/news')"
                      ><i
                        class="fa-solid fa-chevron-right pe-1 primary-color"
                      ></i>
                      {{ $t("g687nj") }}
                    </a>
                  </li>
                  <li>
                    <a :href="localePath('/contact')"
                      ><i
                        class="fa-solid fa-chevron-right pe-1 primary-color"
                      ></i>
                      {{ $t("5x747l") }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer__copyright">
        <p>
          &copy; Copyright 2025 By <a href="https://www.xasre.com">xasre</a> All
          Rights Reserved
        </p>
        <p>
          <a href="https://beian.miit.gov.cn/#/Integrated/index"
            >陕ICP备2025066854号-1</a
          >
        </p>
      </div>
    </footer>

    <!-- 返回顶部区域 -->
    <div class="scroll-up">
      <svg
        class="scroll-circle svg-content"
        width="100%"
        height="100%"
        viewBox="-1 -1 102 102"
      >
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const localePath = useLocalePath();

const { t } = useI18n();
// 使用全局 toast API
const { $toast } = useNuxtApp();

const form = ref({
  name: "",
  email: "",
  company: "empty",
  message: "",
  phone: "",
});

// 在组件挂载后初始化背景图片
onMounted(() => {
  const elements = document.querySelectorAll("[data-background]");
  elements.forEach((element) => {
    const bgImage = element.getAttribute("data-background");
    if (bgImage) {
      element.style.backgroundImage = `url(${bgImage})`;
    }
  });
});

// 提交表单
const submitForm = async () => {
  console.log("点击事件");
  if (!form.value.name) {
    console.log("请输入您的姓名");
    $toast.error(t("9j75ka") || "请输入您的姓名");
    return;
  }
  if (!form.value.email) {
    $toast.error(t("irz8uz") || "请输入有效的邮箱地址");
    return;
  }
  if (!form.value.message) {
    $toast.error(t("fm1yp6") || "请输入项目及产品需求");
    return;
  }
  if (!form.value.phone) {
    $toast.error(t("0o3uca") || "请输入手机号/WhatsApp");
    return;
  }
  const { data: res } = await useFetch<any>("/admin/sreofficial/contact/add", {
    baseURL: useRuntimeConfig().public.apiUrl,
    method: "POST",
    body: form,
  });
  if (res.value && res.value.success) {
    form.value = {
      name: "",
      email: "",
      company: "",
      message: "",
    };
    $toast.success(t("t1ddu1") || "提交成功，我们会尽快与您联系");
    await router.push({
      query: { submitInfo: "true" },
    });
  } else {
    $toast.error(t("brx3od") || "提交失败，请稍后再试");
  }
};
</script>
